/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormCheckboxInput } from '../../../inputs/CheckboxInput';
import { FormCSTextInput } from '../../../inputs/CustomSizeTextInput';
import { FormSmallTextInput } from '../../../inputs/SmallTextInput';
import { DeleteAI } from './DeleteAI';

import { IAgendaItemProps } from './types';

export const AgendaItem: FunctionComponent<IAgendaItemProps> = ({
  index,
  agendaItem,
  removeAgendaItem,
  defaultCheckbox,
  provided,
  setEditableItem,
  onFormModify,
}) => {
  const { control, setValue } = useFormContext();

  const [onEdit, onEditUpdate] = useState(agendaItem.title === '' ? true : false);

  useEffect(() => {
    Object.keys(agendaItem).forEach((key) => {
      setValue(`agendaItems.${index}.${key}`, agendaItem[key] ?? '');
    });
  }, [agendaItem, setValue, index]);

  const watchedValues = useWatch({
    control,
  });

  useEffect(() => {
    if (watchedValues.agendaItems) {
      onFormModify();
    }
  }, [onFormModify, watchedValues]);
  /*
  useEffect(() => {
    if (agendaItem && !disabled) {
      setValue(`agendaItems[${index}].duration`, agendaItem.duration);
    } else if (agendaItem && disabled) {
      setValue(`agendaItems[${index}].duration`, '0');
    }
  }, [agendaItem, disabled, index, setValue]);
*/

  return (
    <div
      className="one-item"
      id={`agendaItems.${index}.id`}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
      draggable={true}
    >
      {agendaItem.id && (
        <>
          <div style={{ display: 'none' }}>
            <FormCSTextInput
              id={`agendaItems.${index}.id`}
              name={`agendaItems.${index}.id`}
              type="text"
              size="small-input"
            />
          </div>
        </>
      )}
      <div style={{ display: 'none' }}>
        <FormCSTextInput
          id={`agendaItems.${index}.keyName`}
          name={`agendaItems.${index}.keyName`}
          type="text"
          size="small-input"
        />
        <FormCSTextInput
          id={`agendaItems.${index}.boardId`}
          name={`agendaItems.${index}.boardId`}
          type="text"
          size="small-input"
        />
        <FormCSTextInput
          id={`agendaItems.${index}.boardListId`}
          name={`agendaItems.${index}.boardListId`}
          type="text"
          size="small-input"
        />
        <FormCSTextInput
          id={`agendaItems.${index}.embedUrl`}
          name={`agendaItems.${index}.embedUrl`}
          type="text"
          size="small-input"
        />
      </div>
      <div style={{ display: 'none' }}>
        <FormCSTextInput
          id={`agendaItems.${index}.sort`}
          name={`agendaItems.${index}.sort`}
          type="text"
          size="small-input"
        />
      </div>
      <div style={{ display: 'none' }}>
        <FormCSTextInput
          id={`agendaItems.${index}.description`}
          name={`agendaItems.${index}.description`}
          type="text"
          size="small-input"
        />
      </div>
      <i className="icon-hamburger" />
      <div className="flex aic jcl">
        {defaultCheckbox ? (
          <FormCheckboxInput
            id={`agendaItems.${index}.checked`}
            name={`agendaItems.${index}.checked`}
            defaultChecked={agendaItem.checked}
          />
        ) : (
          <></>
        )}
        <label
          htmlFor={`agendaItems.${index}.checked`}
          style={onEdit ? { marginBottom: '13px', position: 'relative' } : { position: 'relative' }}
        >
          <label
            style={
              onEdit
                ? { display: 'none', color: 'white' }
                : {
                    display: 'block',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: 'white',
                  }
            }
          >
            .
          </label>
        </label>
        <div onBlur={() => onEditUpdate(false)}>
          <FormSmallTextInput id={`agendaItems.${index}.title`} name={`agendaItems.${index}.title`} type="text" />
        </div>
      </div>
      <div className="input-with-label">
        <FormCSTextInput
          id={`agendaItems.${index}.duration`}
          name={`agendaItems.${index}.duration`}
          type="text"
          size="mw"
        />

        <span className="input-label">Minutes</span>
      </div>
      <div style={{ paddingLeft: '5px' }} onClick={() => setEditableItem({ ...agendaItem, index })}>
        <a className="round-icon-small mr-0 popup_button">
          <i className="icon icon-pencil" />
        </a>
      </div>
      <DeleteAI agendaItem={index} removeAgendaItem={removeAgendaItem} />
    </div>
  );
};
